export default {
  path: '/finance',
  name: 'finance',
  component: () => import('../../views/Layout/index'),
  meta: {
    title: '财务',
    // keepAlive: false
  },
  children: [
    {
      // 财务-账单明细
      path: 'billIndex',
      name: 'billIndex',
      component: () => import('../../views/Finance/Bill/BillIndex'),
      meta: { title: '账单明细', keepAlive: false }
    },
    {
      // 财务-账单明细-查看详情
      path: 'billDetail',
      name: 'billDetail',
      hidden: true,
      component: () => import('../../views/Finance/Bill/BillDetail'),
      meta: { title: '查看详情', keepAlive: false }
    },
    {
      // 财务-资金管理
      path: 'fundManageIndex',
      name: 'fundManageIndex',
      component: () => import('../../views/Finance/FundManage/FundManageIndex'),
      meta: { title: '资金管理', keepAlive: false }
    },
    {
      // 财务-资金管理-资金明细
      path: 'fundManageDetail',
      name: 'fundManageDetail',
      hidden: true,
      component: () => import('../../views/Finance/FundManage/FundManageDetail'),
      meta: { title: '资金明细', keepAlive: false }
    },
  ]
}